import { useSelector } from 'react-redux';

import { getGeoLocation } from './intlModule';

export default function useGeoLocationByIP() {
  return useSelector(getGeoLocation);
}
